// libs
import { connect } from 'react-redux';

// redux selectors
import {
  getErrorStatusCode,
  getProductId,
  isFetching,
  isFetchingError,
  isNotFound,
} from 'shared/store/details/selectors';

// component
import ErrorWrapper from './ErrorWrapper';

const mapStateToProps = (state: any) => ({
  isFetching: isFetching(state),
  isFetchingError: isFetchingError(state),
  isNotFound: isNotFound(state),
  productID: getProductId(state),
  statusCode: getErrorStatusCode(state),
});

export default connect(mapStateToProps)(ErrorWrapper);
